/**
 * PageSourceService
 */
import { Injectable } from '@angular/core';
import { RoutePaths } from '../../../shared/constants/route-paths.constant';

/**
 * Page source service.
 */
@Injectable({
    providedIn: 'root',
})
export class PageSourceService {
    /**
     * Constructor.
     */
    constructor() {}

    /**
     * Get page source.
     */
    getPageSourceForUber(): string {
        const currentUrl = globalThis.location.pathname;
        if (currentUrl.includes('dashboard')) {
            return 'dashboard';
        } else if (currentUrl.includes('my-account')) {
            return 'dashboard';
        } else if (currentUrl.includes('uber/authorize')) {
            return 'authorize';
        }
        switch (currentUrl) {
            case `/${RoutePaths.JOIN}`:
                return 'signup';
            case `/${RoutePaths.INFO}`:
                return 'info';
            case `/${RoutePaths.PROFILE}`:
                return 'profile';
            case `/${RoutePaths.PAYMENT}`:
                return 'payment';
            case `/${RoutePaths.COMPLETE}`:
                return 'complete';
            default:
                return 'dashboard';
        }
    }
}
